import {UPDATE_EVENTS_ERROR, UPDATE_EVENTS_START, UPDATE_EVENTS_SUCCESS} from "../../types";

export default function update_events(state, action) {
    switch (action.type) {
        case UPDATE_EVENTS_START:
            return {
                ...state,
                loading: true,
                error: null
            };
        case UPDATE_EVENTS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };
        case UPDATE_EVENTS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.detail
            };
        default:
            return {...state};
    }
}
